import { config } from '@/config'
import { ThemeColor } from '@/enums'
import styled, { css, keyframes } from 'styled-components'
import { ifProp } from 'styled-tools'
import { Typography } from '../../atoms'

const backgroundUrl = `${config.cdn}/sign.png`

const TouchedStyles = css`
  background: none;
`

export const Container = styled.div<{ isTouched: boolean }>`
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 200px;
  // This makes the border dashed, but we cannot use native border-dashed because it cannot be customized

  background: ${({ theme }) => theme.color.b0};
  background-image: url('/assets/dotted.svg');
  border-radius: 8px;

  canvas {
    width: 100%;
    height: 200px;
    background-image: url(${backgroundUrl});
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center 40%;

    ${ifProp('isTouched', TouchedStyles)};
  }
`

export const InfoSection = styled(Typography).attrs({
  variant: 'p2Body',
  color: ThemeColor.b50,
})`
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 2;
`

const showClearIcon = keyframes`
0% {
  opacity: 0
}
`
export const Clear = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.color.b0};
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 8px;
  animation: ${showClearIcon} 0.4s;
  display: flex;
  justify-content: center;
  align-items: center;
`
